import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// import BootstrapTable from 'react-bootstrap-table-next';
// import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import '../subscriptions.css';
// import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css';
// import filterFactory, { textFilter, selectFilter } from 'react-bootstrap-table2-filter';
// import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';


class ViewCustomer extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (

    <div className="modal fade" id="view_customer_modal" tabIndex="-1" role="dialog" aria-labelledby="RejectModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">User Details</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="form-group m-form__group row cust_view">
                                <label className="col-4 col-form-label">Name :</label>
                            <div className="col-8 col-form-label">Kavinda Silva </div>
                            </div>
                        <div className="form-group m-form__group row cust_view">
                            <label className="col-4 col-form-label">Email :</label>
                            <div className="col-8 col-form-label">kavindasilva2005@gmail.com</div>
                        </div>
                        <div className="form-group m-form__group row cust_view">
                            <label className="col-4 col-form-label">Address :</label>
                            <div className="col-8 col-form-label">220, Diggala Rd, Keselwatta</div>
                        </div>
                        <div className="form-group m-form__group row cust_view">
                            <label className="col-4 col-form-label">Address(optional) :</label>
                            <div className="col-8 col-form-label"></div>
                        </div>
                        <div className="form-group m-form__group row cust_view">
                            <label className="col-4 col-form-label">State :</label>
                            <div className="col-8 col-form-label">Western</div>
                        </div>
                        <div className="form-group m-form__group row cust_view">
                            <label className="col-4 col-form-label">City :</label>
                            <div className="col-8 col-form-label">Panadura</div>
                        </div>
                        <div className="form-group m-form__group row cust_view">
                            <label className="col-4 col-form-label">ZIP Code :</label>
                            <div className="col-8 col-form-label">12550</div>
                        </div>
                        <div className="form-group m-form__group row cust_view">
                            <label className="col-4 col-form-label">Primary Phone :</label>
                            <div className="col-8 col-form-label">+0772000919()</div>
                        </div>
                        <div className="form-group m-form__group row cust_view">
                            <label className="col-4 col-form-label">Secondary Phone :</label>
                            <div className="col-8 col-form-label">+94112612627()</div>
                        </div>
                        <div className="form-group m-form__group row cust_view">
                            <label className="col-4 col-form-label">How find us? :</label>
                            <div className="col-8 col-form-label">Drive By</div>
                        </div>
                        <div className="form-group m-form__group row">
                            <label className="col-4 col-form-label">Created at :</label>
                            <div className="col-8 col-form-label">2018-10-17</div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(ViewCustomer));